import React, { useCallback } from 'react'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import HeadingTextBlock from 'components/Luxkit/TextBlocks/HeadingTextBlock'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import FlashHotelAvailabilityButton from '../FlashHotelAvailabilityButton'

interface Props {
  additionalDescriptionMarkdown: string;
  highlightsMarkdown: string;
}

function FlashHotelInclusionsAndHighlightsModal(props: Props) {
  const {
    additionalDescriptionMarkdown,
    highlightsMarkdown,
  } = props

  const modalElement = useModalElementContext()

  const onCTAClick = useCallback(() => {
    modalElement.resolve()
  }, [modalElement])

  return (
    <ModalBase>
      <ModalHeader title="Inclusions & Highlights"/>
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={24}>
            <MarkdownRender type="compact" content={additionalDescriptionMarkdown} />
            <HeadingTextBlock variant="heading4">
              Highlights
            </HeadingTextBlock>
            <MarkdownRender type="compact" fontSize="large" content={highlightsMarkdown} />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <FlashHotelAvailabilityButton onClick={onCTAClick}/>
      </ModalFooter>
    </ModalBase>
  )
}

export default FlashHotelInclusionsAndHighlightsModal
